import { Stack } from '@mui/material'
import React from 'react'
import { Avatar, Name } from '../components'


const Home = () => {
  return (
    <Stack height={'100%'} direction={'column-reverse'} sx={{flexDirection:{sm:'column-reverse',md:'row'}, justifyContent:'space-evenly'}}>
      <Name/>
      <Avatar/>
    </Stack>
  )
}

export default Home